import { quizConfig, setQuizConfig } from "./quiz";
import { validateQuizConfig } from "../../supabase/functions/_shared/quiz-config";
import type { QuizConfig } from "../types";

const submitEndpoint = import.meta.env.VITE_SUBMIT_ENDPOINT as string | undefined;
export const settingsEndpoint = submitEndpoint?.replace(/\/submit-entry\/?$/, "/quiz-settings");

export async function loadLiveQuizConfig(): Promise<void> {
  if (!settingsEndpoint) return;
  const response = await fetch(settingsEndpoint, { headers: { Accept: "application/json" }, cache: "no-store" });
  if (!response.ok) throw new Error("Quiz settings could not be loaded. Please try again shortly.");
  const payload = await response.json() as { config?: unknown };
  if (payload.config) setQuizConfig(validateQuizConfig(payload.config) as QuizConfig);
  else setQuizConfig(quizConfig);
}
